import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE =
  "حاسبة محيط الأسطوانة - حساب محيط الأسطوانة بناءً على القطر والارتفاع";
const DESCRIPTION =
  "حاسبة محيط الأسطوانة: احسب محيط القاعدة أو المحيط الكلي للأسطوانة بدقة! أدخل القطر (أو نصف القطر) والارتفاع للحصول على النتائج فوراً - مع شرح القوانين الرياضية المستخدمة.";
const KEYWORDS = "محيط الأسطوانة, حساب محيط الأسطوانة, حاسبة محيط الأسطوانة";
const OG_URL = "https://do-calculate.com/calculator/ar/cylinder-circumference";
function Calculator() {
  const [diameter, setDiameter] = useState("");
  const [height, setHeight] = useState("");
  const [circumference, setCircumference] = useState("");
  const [error, setError] = useState("");
  const [solutionSteps, setSolutionSteps] = useState([]);
  const handleCalculate = () => {
    if (!diameter || !height) {
      setError("الرجاء إدخال القطر والارتفاع بشكل صحيح");
      setCircumference("");
      return;
    }
    const generateSolutionSteps = (diameter, height, circumference) => {
      const steps = [];
      steps.push(
        `الخطوة 1: قم بإدخال القطر (${diameter}) والارتفاع (${height})`
      );
      steps.push(
        `الخطوة 2: حساب محيط الأسطوانة بواسطة القانون: 2 × π × القطر = 2 × π × ${diameter} = ${circumference}`
      );
      steps.push(`الخطوة 3: تم حساب محيط الأسطوانة بنجاح`);
      return steps;
    };
    const diameterValue = parseFloat(diameter);
    const heightValue = parseFloat(height);
    if (
      isNaN(diameterValue) ||
      isNaN(heightValue) ||
      diameterValue <= 0 ||
      heightValue <= 0
    ) {
      setError("الرجاء إدخال قيم صحيحة وموجبة للقطر والارتفاع");
      setCircumference("");
      return;
    }
    const circumferenceValue = 2 * Math.PI * diameterValue;
    setCircumference(circumferenceValue.toFixed(2));
    const steps = generateSolutionSteps(
      diameterValue,
      heightValue,
      circumferenceValue.toFixed(2)
    );
    setSolutionSteps(steps);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>كيفية حساب محيط الأسطوانة</h2>
                <p>
                  لحساب محيط الأسطوانة، يجب عليك إدخال القطر والارتفاع. ثم سيتم
                  حساب محيط الأسطوانة ببساطة بواسطة القانون التالي:
                </p>
                <p>محيط الأسطوانة = 2 × π × القطر</p>
                <p>
                  يمكنك استخدام هذه الحاسبة لحساب محيط الأسطوانة بناءً على
                  الأرقام المُدخلة.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">القطر</label>
                      </b>
                      <input
                        type="number"
                        placeholder="القطر"
                        value={diameter}
                        onChange={(e) => setDiameter(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الارتفاع</label>
                      </b>
                      <input
                        type="number"
                        placeholder="الارتفاع"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب محيط الأسطوانة
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {circumference !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              محيط الأسطوانة: {circumference}
                            </p>
                            <div className="p-3 mb-2 bg-info">
                              <b>خطوات الحل</b>
                              <ol>
                                {solutionSteps.map((step, index) => (
                                  <li key={index}>{step}</li>
                                ))}
                              </ol>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
